<template>
  <div id="tradingview" class="ao-tv" style="width:100%;height:535px;"></div>
</template>

<script>
import AoWidget from "./AoTv-widget";

export default {
  props: {
    priceScale: {
      type: String,
      default: "1min"
    },
    currency: {
      type: String,
      default: "EOS"
    }
  },
  data() {
    return {
      symbol: "",
      widget: null
    };
  },
  mounted() {
    this.symbol = (this.currency || "EOS") + "/USDT";
    this.widget = null
    localStorage.setItem("type2", "1min");

    this.createWidget();
  },
  computed: {
    listenState() {
      //监听交易对
      return this.currency;
    }
  },
  watch: {
    listenState: (a, b) => {
      if (a != b && !!b) {
        this.symbol = a + "/USDT";
        console.log(this);
      }
    }
  },
  methods: {
    test() {
      console.log("test");
    },
    createWidget() {
      this.$nextTick(() => {
        const container_id = "tradingview";
        const width = "100%";
        const height = 535;
        const priceScale = this.priceScale;
        const symbol = this.symbol;
        var widget = this.widget = new AoWidget({
          container_id,
          width,
          height,
          priceScale,
          symbol
        });
        widget.create().ready();
      });
    }
  }
};
</script>

<style lang="scss">
.ao-tv {
}
</style>



// WEBPACK FOOTER //
// src/views/preciousMetal/components/AoTv.vue